export enum GlobalTexts {
	Incomplete = "790A93CA-01B5-4ABF-ADB2-4A3C4A9EC2C0",
	NotAttempted = "30A3D62B-09E7-46C2-B85E-4FFCBB28D206",
	Completed = "E01272B0-6AA5-4F54-9C5A-31EAB916753F",
	Locked = "79787664-F8AF-439B-97A2-2A57CAD76E7B",
}
